import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { ButtonGroup as BaseButtonGroup } from 'reactstrap'

import bindActionCreators from '../../../../lib/utils/bindActionCreators'

import Button from '../../../../lib/components/Button'

import { setGP } from '../actions'
import { getGP } from '../selectors'

/**
 * @typedef {import('../model').GPType} GPType
 */

const ButtonGroup = styled(BaseButtonGroup)`
  background-color: #fff;

  ${Button} {
    width: 100px;
    height: 30px;
    padding: 0;

    justify-content: center;
  }
`

/**
 * @typedef {object} Props
 * @property {GPType} gp
 * @property {typeof setGP} setGP
 */

/** @extends {Component<Props, *>} */
export class GPTab extends Component {
  /** @type {Props} */
  static defaultProps = {
    gp: 'service',
    setGP: () => {},
  }

  /** @type {(gp: GPType) => () => void} */
  changeActive = gp => () => this.props.setGP(gp)

  render = () => {
    const { gp } = this.props
    return (
      <ButtonGroup>
        <Button
          color="danger"
          outline={ gp !== 'all' }
          onClick={ this.changeActive('all') }
        >
          GP All
        </Button>
        <Button
          color="danger"
          outline={ gp !== 'service' }
          onClick={ this.changeActive('service') }
        >
          GP Service
        </Button>
      </ButtonGroup>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  gp: getGP,
})

const mapDispatchToProps = bindActionCreators({
  setGP,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GPTab)



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/components/GPTab.jsx